"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function reducer(state, action) {
    switch (action.type) {
        case "begin":
            return __assign(__assign({}, state), { status: "pending", pending: true, error: null });
        case "success":
            return __assign(__assign({}, state), { status: "success", pending: false, data: action.data, error: null });
        case "error":
            return __assign(__assign({}, state), { status: "error", pending: false, data: null, error: action.error });
    }
}
/**
 *
 * @param {function} asyncFunction
 * @param {boolean} immediate
 *
 * A hook that calls a function which takes no parameters and
 * returns a promise, returning the result, the error (if the promise rejects),
 * and whether the promise is pending.
 */
function useAsyncFunction(asyncFunction, immediate) {
    if (immediate === void 0) { immediate = true; }
    var _a = React.useReducer(reducer, {
        status: "idle",
        pending: false,
        data: null,
        error: null,
    }), store = _a[0], dispatch = _a[1];
    var execute = React.useCallback(function () {
        dispatch({ type: "begin" });
        return asyncFunction()
            .then(function (data) { return dispatch({ type: "success", data: data }); })
            .catch(function (error) { return dispatch({ type: "error", error: error }); });
    }, [asyncFunction]);
    React.useEffect(function () {
        if (immediate) {
            execute();
        }
    }, [execute, immediate]);
    return __assign({ execute: execute }, store);
}
exports.useAsyncFunction = useAsyncFunction;
